import dynamic from 'next/dynamic'
import React from 'react'
import { isMobile } from 'react-device-detect'

import OICircularLoader from '@components/UI/atoms/OICircularLoader'

// Dynamically import HorizontalScrollSection only when needed
const HorizontalScrollSection = dynamic(() => import('./HorizontalScrollSection'), {
  ssr: false,
  loading: () => (
    <div className="flex h-32 w-full items-center justify-center">
      <OICircularLoader size={20} strokeWidth={2} />
    </div>
  ),
})

interface ResponsiveCardGridProps {
  children: React.ReactNode
  gridClasses?: string
  className?: string
  mobileCarouselConfig?: {
    showArrows?: boolean
    showDots?: boolean
    customResponsive?: any
    autoPlay?: boolean
    loop?: boolean
    itemClass?: string
    customContainerStyle?: string
    afterChange?: (index: number) => void
  }
}

const ResponsiveCardGrid: React.FC<ResponsiveCardGridProps> = ({
  children,
  gridClasses = 'grid gap-4 md:grid-cols-3',
  className = '',
  mobileCarouselConfig = {},
}) => {
  const defaultMobileResponsive = {
    tablet: {
      breakpoint: { max: 768, min: 640 },
      items: 1,
      slidesToSlide: 1,
      partialVisibilityGutter: 40,
    },
    mobile: {
      breakpoint: { max: 640, min: 0 },
      items: 1,
      slidesToSlide: 1,
      partialVisibilityGutter: 20,
    },
  }

  const carouselConfig = {
    showArrows: false,
    showDots: false,
    partialVisible: true,
    itemClass: 'pr-2 last:pr-0',
    customResponsive: defaultMobileResponsive,
    ...mobileCarouselConfig,
  }

  if (isMobile) {
    return (
      <div className={className}>
        <HorizontalScrollSection {...carouselConfig}>{children}</HorizontalScrollSection>
      </div>
    )
  }

  // Desktop: render in grid layout
  return (
    <div className={className}>
      <div className={gridClasses}>{children}</div>
    </div>
  )
}

export default ResponsiveCardGrid
